/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 *
 * @author Evgenij Tyan
 * @author Aleksandr Perkhunov
 * @version 1.2.0
 * @since 1.1.0
 */
const appPolyfill = () => {
    if (!Element.prototype.matches) {
        Element.prototype.matches = (Element.prototype as any).matchesSelector
            || (Element.prototype as any).webkitMatchesSelector 
            || (Element.prototype as any).mozMatchesSelector
            || (Element.prototype as any).msMatchesSelector;
    
    }
    if (!Element.prototype.closest) {
        Element.prototype.closest = function (css: any) {
            let node: any = this;

            while (node) {
                if (node.matches(css)) return node;
                else node = node.parentElement;
            }
            return null;
        };
    }
};
export default appPolyfill;
